import React  from 'react';
import { Form, Input, Button, message, Icon, Switch } from 'antd';
import BaseComponent from '../../../../../base/BaseComponent';
import UploadWall from '../../../../../components/upload/UploadWall';
import PageTemplate from '../../../components/pageTemplate/PageTemplate';
import {Scrollbars} from "react-custom-scrollbars";
import FieldsTable from "../positionMaintenance/components/fieldsTable";

class SystemSetting extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            itemCode: "",
            vsbHost: "",
            itemCodeStatus: "",
            itemCodeMessage: "",
            checkButtonLoading: false,
            fileList: [],
            positionRecordedUrl: {},
            isPass: false,
            positionRecordOnlineList: []
        };

        this.fileType = ["doc","docx","xls","xlsx","rar","zip"];

        this.electricFileType = ["xls","xlsx"];

    }

    componentDidMount() {
        this.getSystemSetting();
        window.addEventListener('resize', this.handleResize);
        this.handleResize(); // 初始化时调用一次
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const screenWidth = window.innerWidth;
        let labelColSpan = 3; // 根据屏幕宽度调整 span 值
        if (screenWidth <= 1440 && screenWidth >= 1098) {
            labelColSpan = 4;
        } else if (screenWidth < 1098) {
            labelColSpan = 5;
        }
        this.setState({ labelColSpan });
    };

    renderTop() {
        return (
            <div style={{
                fontSize: 16,
                color: "#222",
                height: 54,
                lineHeight: "54px",
                borderBottom: "1px solid #ddd"
            }}><span style={{paddingLeft: 24}}>
                更多设置
            </span></div>
        )
    }

    render() {
        const { itemCodeStatus,itemCodeMessage, checkButtonLoading, itemCode,vsbHost, fileList, tenantId, positionRecordOnlineOpen, differentRecordOnline, labelColSpan } = this.state;
        return (
            <PageTemplate style={{
                maxHeight: "calc(100vh - 100px)",
                padding: 0
            }}>
                {this.renderTop()}
                <Scrollbars autoHide autoHeight autoHeightMax={'calc(100vh - 154px)'}>
                    <div style={{padding: 24}} className={"system-setting-content"}>
                        <div style={{ fontSize: "14px", fontWeight: 700, color: "#000000", marginBottom: "31px"}}>新媒体矩阵管理</div>
                        <Form
                            className='system-setting-content'
                            style={{ display: "flex", flexDirection: "column"}}
                            layout="horizontal"
                            labelCol={{span: labelColSpan}}
                            labelAlign='left'
                            wrapperCol={{span:17}}
                        >
                            <Form.Item
                                label="运维提示地址"
                            >
                                <Input placeholder={"请输入运维提示地址"} value={vsbHost} style={{width: "341px"}} onChange={(e)=>this.valueChange(e.target.value,"vsbHost")}/>
                            </Form.Item>
                            <Form.Item
                                label="客户编码"
                                help={itemCodeMessage}
                                className='position-setting-codeMessage'
                                validateStatus={itemCodeStatus}
                            >
                                <div style={{display: "flex",flexDirection: "row",gap: "10px"}}>
                                    <Input placeholder={"请输入客户编码"} value={itemCode} style={{width: "341px"}} onChange={(e)=>this.valueChange(e.target.value,"itemCode")} />
                                    <Button loading={checkButtonLoading} onClick={()=>this.codeCheck()}>验证地址</Button>
                                    <Button type="primary" onClick={()=>{this.saveCodeAndHost()}}>保存</Button>
                                </div>
                                <style>
                                    {
                                        `
                                        .position-setting-codeMessage > .ant-form-item-control-wrapper > .has-success > .ant-form-explain { color: #52c41a !important;}
                                        `
                                    }
                                </style>
                            </Form.Item>
                            <Form.Item
                                label="安全检测用户租户ID"
                            >
                                <div style={{display: "flex",flexDirection: "row",gap: "10px"}}>
                                    <Input placeholder={"请输入租户ID"} value={tenantId} style={{width: "341px"}} onChange={(e)=>this.valueChange(e.target.value,"tenantId")} />
                                    <Button type="primary" onClick={()=>{this.saveTenantId()}}>保存</Button>
                                </div>
                            </Form.Item>
                            <Form.Item
                                label="纸质备案表模板"
                            >
                                <UploadWall
                                    action="/storage/uploadFile"
                                    uploadBtnName={<>
                                        <Button><Icon type="upload"/>点击上传</Button>
                                        <span onClick={(e) => {
                                            e.stopPropagation();
                                        }}><span style={{fontSize: "12px",color: "#999",marginLeft: "10px", verticalAlign: "bottom"}}>提示：用户手动下载填写后可扫描上传（根据实际业务情况与电子备案表任选其一，可在平台字段维护中开启）</span></span>
                                    </>}
                                    showUploadBtn={true}
                                    listType="list"
                                    fileList={this.state.fileList}
                                    icons={["download", "delete"]}
                                    beforeUpload={(file)=>{
                                        const upperCaseType = this.fileType?.map(item=>item.toUpperCase())
                                        const finalType = [...this.fileType,...upperCaseType];
                                        const typeResult = finalType.some(item=>file.name.endsWith(item));
                                        if (!typeResult) {
                                            message.warning("文件格式错误");
                                            return Promise.reject();
                                        }
                                        return Promise.resolve(file);
                                    }}
                                    accept={this.fileType.map(item=>"."+item).join(",")}
                                    describe={<p style={{marginTop: "5px"}}><span style={{color: "#00000072",fontSize: "14px"}}>支持扩展名：{this.fileType.map(item=>"."+item).join(" ")}</span></p>}
                                    onChange={({file,fileList})=>{
                                        const temp = [];
                                        temp[0] = {
                                            ...file,
                                            response: {...file.response?.data, ...file.response,data:file.response?.data},
                                            ext:  file.response?.data ? file.response.data.suffix : file.response?.suffix,
                                            url : file.response?.data ? file.response.data.path : file.response?.path,
                                            path :file.response?.data ? file.response.data.path : file.response?.path,
                                            name : file.response?.data ? file.response.data.name: file.response?.name,
                                            md5: file.response?.data ? file.response.data.md5: file.response?.md5,
                                            _id: file.response?.data ? file.response.data._id: file.response?._id,
                                        };
                                        if (file.status === 'done') {
                                            this.setState({
                                                fileList: temp
                                            })
                                        }
                                    }}
                                    onDownload={()=>{this.clickDownload(this.state.fileList[0])}}
                                    onRemove={this.handleRemove}
                                    onSuccess={(response,file)=>{
                                        const temp = [];
                                        if (response.status === 200) {
                                            temp[0] = {
                                                ...file,
                                                response: {...response?.data, ...response,data:file.response?.data},
                                                ext:  response?.data ? response.data.suffix : response?.suffix,
                                                url : response?.data ? response.data.path : response?.path,
                                                path :response?.data ? response.data.path : response?.path,
                                                name : response?.data ? response.data.name: response?.name,
                                                md5: response?.data ? response.data.md5: response?.md5,
                                                _id: response?.data ? response.data._id: response?._id,
                                            }
                                            this.saveTemplate(response.data, 1);
                                            this.setState({
                                                fileList: temp,
                                            })
                                        }else {
                                            message.error(response?.message);
                                        }
                                    }}
                                    onError={(error)=>{
                                        message.error(error);
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                label="生成电子备案表"
                            >
                                <Switch checked={positionRecordOnlineOpen} onChange={(checked)=>{
                                    message.success(checked ? "已开启" : "已关闭");
                                    this.setState({
                                        positionRecordOnlineOpen: checked
                                    }, () => {
                                        this.getElectricRecordTable()
                                    })
                                }}/>
                                <span style={{fontSize: "12px",color: "#999",marginLeft: "10px", verticalAlign: "bottom"}}>提示：开启后系统会根据填写内容自动生成PDF电子备案表（根据实际业务情况与纸质备案表任选其一）</span>
                            </Form.Item>
                            {positionRecordOnlineOpen &&
                                <Form.Item
                                    label="不同平台独立备案表"
                                >
                                    <Switch checked={differentRecordOnline} onChange={(checked)=>{
                                        message.success(checked ? "已开启" : "已关闭");
                                        this.setState({
                                            differentRecordOnline: checked
                                        }, () => {
                                            this.getDifferentRecordOnline()
                                        })
                                    }}/>
                                    <span style={{
                                        fontSize: "12px",
                                        color: "#999",
                                        marginLeft: "10px",
                                        verticalAlign: "bottom"
                                    }}>提示：开启后可在“系统设置-平台维护”中设置各类型平台独有的备案表模板，如所有平台备案表字段级模板一致，则关闭此开关，使用下方统一的备案表模板</span>
                                </Form.Item>}
                            {positionRecordOnlineOpen && !differentRecordOnline &&
                                <Form.Item
                                    label="电子备案表模板"
                                >
                                    <UploadWall
                                        action="/storage/uploadFile"
                                        uploadBtnName={<>
                                            <Button><Icon type="upload"/>点击上传</Button>
                                            <span onClick={(e) => {
                                                e.stopPropagation()
                                            }}>
                                            <span onClick={(e) => {
                                                this.fieldsTable.viewFieldsTable()
                                            }} style={{
                                                color: "#008dff",
                                                paddingLeft: "10px",
                                                cursor: "pointer"
                                            }}>查看字段表</span>
                                        <span style={{fontSize: "12px", color: "#999", paddingLeft: "10px"}}
                                              onClick={(e) => {
                                              }}>查看字段表字段键值，将键值填写入备案表模板对应位置中，保存模板上传即可</span>
                                        </span>
                                        </>}
                                        showUploadBtn={true}
                                        listType="list"
                                        fileList={this.state.positionRecordOnlineList}
                                        icons={["download", "delete"]}
                                        beforeUpload={(file) => {
                                            const upperCaseType = this.electricFileType?.map(item => item.toUpperCase())
                                            const finalType = [...this.electricFileType, ...upperCaseType];
                                            const typeResult = finalType.some(item => file.name.endsWith(item));
                                            if (!typeResult) {
                                                message.warning("文件格式错误");
                                                return Promise.reject();
                                            }
                                            return Promise.resolve(file);
                                        }}
                                        accept={this.electricFileType.map(item => "." + item).join(",")}
                                        describe={<p style={{marginTop: "5px"}}><span style={{
                                            color: "#00000072",
                                            fontSize: "14px"
                                        }}>支持扩展名：{this.electricFileType.map(item => "." + item).join(" ")}</span></p>}
                                        onChange={({file, fileList}) => {
                                            const temp = [];
                                            temp[0] = {
                                                ...file,
                                                response: {
                                                    ...file.response?.data, ...file.response,
                                                    data: file.response?.data
                                                },
                                                ext: file.response?.data ? file.response.data.suffix : file.response?.suffix,
                                                url: file.response?.data ? file.response.data.path : file.response?.path,
                                                path: file.response?.data ? file.response.data.path : file.response?.path,
                                                name: file.response?.data ? file.response.data.name : file.response?.name,
                                                md5: file.response?.data ? file.response.data.md5 : file.response?.md5,
                                                _id: file.response?.data ? file.response.data._id : file.response?._id,
                                            };
                                            if (file.status === 'done') {
                                                this.setState({
                                                    positionRecordOnlineList: temp
                                                })
                                            }
                                        }}
                                        onDownload={() => {
                                            this.clickDownload(this.state.positionRecordOnlineList[0])
                                        }}
                                        onRemove={this.positionRecordOnlineRemove}
                                        onSuccess={(response, file) => {
                                            const temp = [];
                                            if (response.status === 200) {
                                                temp[0] = {
                                                    ...file,
                                                    response: {...response?.data, ...response, data: file.response?.data},
                                                    ext: response?.data ? response.data.suffix : response?.suffix,
                                                    url: response?.data ? response.data.path : response?.path,
                                                    path: response?.data ? response.data.path : response?.path,
                                                    name: response?.data ? response.data.name : response?.name,
                                                    md5: response?.data ? response.data.md5 : response?.md5,
                                                    _id: response?.data ? response.data._id : response?._id,
                                                }
                                                this.saveElectricTemplate(response.data, 1);
                                                this.setState({
                                                    positionRecordOnlineList: temp,
                                                })
                                            } else {
                                                message.error(response?.message);
                                            }
                                        }}
                                        onError={(error) => {
                                            message.error(error);
                                        }}
                                    />
                                </Form.Item>}
                        </Form>
                        <style>{`.system-setting-content .ant-input{background: rgba(0, 80, 179, 0.04) !important;border: 1px solid rgba(0, 80, 179, 0.08)}`}</style>
                    </div>
                </Scrollbars>
                <FieldsTable ref={ref => this.fieldsTable = ref} viewAll={true}/>
            </PageTemplate>
        )
    }

    handleRemove = async file => {
        this.setState(prevState => {
            let fileList = prevState.fileList.filter(item=>{
                return item.uid !== file.uid
            });
            this.saveTemplate({}, 2);
            return {
                fileList
            }
        });
    };

    positionRecordOnlineRemove = async file => {
        this.setState(prevState => {
            let positionRecordOnlineList = prevState.positionRecordOnlineList.filter(item=>{
                return item.uid !== file.uid
            });
            this.saveElectricTemplate({}, 2);
            return {
                positionRecordOnlineList
            }
        });
    };

    // 客户编码校验方法
    codeCheck() {
        const { itemCode,vsbHost } = this.state;
        this.setState({
            itemCodeStatus: "validating",
            checkButtonLoading: true,
        })
        this.request({
            url: "/cm-sites-media-consumer/system/verifyCustom",
            body: {itemCode,vsbHost},
            callBack: (response)=>{
                if (response) {
                    this.setState({
                        itemCodeStatus: "success",
                        itemCodeMessage: '验证通过',
                        checkButtonLoading: false,
                        isPass: true,
                    })
                }else{
                    this.setState({
                        itemCodeStatus: "error",
                        itemCodeMessage: "验证不通过",
                        checkButtonLoading: false,
                        isPass: false,
                    })
                }
            },
            errorCallBack:(error) =>{
                this.setState({
                    itemCodeStatus: "error",
                    checkButtonLoading: false,
                    isPass: false,
                })
            }
        })
    }

    fileOnChange({file,fileList}) {
        const fileListTemp = fileList.map(item=>({
            ...item,
            uid: item.uid,
            response: {...item.response?.data, ...item.response},
            ext:  item.response?.data && item.response.data.suffix,
            url : item.response?.data && item.response.data.path,
            path :item.response?.data && item.response.data.path,
            name : item.response?.data && item.response.data.name,
            md5: item.response?.data && item.response.data.md5,
            _id: item.response?.data && item.response.data._id,
            isChunk : true,
        }))
        if (file.response&&file.response?.data) {
            this.setState({
                fileList: fileListTemp,
                positionRecordedUrl: file.response?.data
            })
        }else{
            this.setState({
                fileList: fileListTemp,
            })
        }
    }

    valueChange(value,key) {
        const temp = this.state
        if (key) {
            temp[key] = value;
            this.setState({
                ...temp,
            })
        }
    }

    saveCodeAndHost() {
        const { itemCode, vsbHost, itemCodeStatus,isPass } = this.state;
        message.destroy();
        if (!vsbHost) {
            message.warning("请输入运维提示地址");
            return;
        }
        if (!itemCode) {
            message.warning("请输入客户编码");
            return;
        }
        if (!isPass) {
            message.warning("校验未通过,请修改");
            return
        }
        this.request({
            url: "/cm-sites-media-consumer/system/saveCustomInfo",
            body: {itemCode,vsbHost},
            callBack:(response)=>{
                if (response) {
                    message.success("保存成功");
                }
            }
        })
    }

    saveTenantId() {
        const { tenantId } = this.state;
        message.destroy();
        if (!tenantId) {
            message.warning("请输入安全检测用户租户ID");
            return;
        }
        this.request({
            url: "/cm-sites-media-consumer/system/saveTenantId",
            method: "post",
            body: {tenantId},
            callBack:(response)=>{
                if (response) {
                    message.success("保存成功");
                }
            }
        })
    }

    saveTemplate(fileData, type) {
        this.request({
            url: "/cm-sites-media-consumer/system/saveRecordedUrl",
            body: fileData,
            method: "post",
            contentType: "json",
            callBack:(response)=>{
                if (response) {
                    this.setState({
                        positionRecordedUrl: fileData,
                    })
                    if(type === 1) {
                        message.success("上传成功");
                    }else if(type === 2) {
                        message.success("删除成功");
                    }
                }
            }
        })
    }

    saveElectricTemplate(fileData, type) {
        this.request({
            url: "/cm-sites-media-consumer/system/saveRecordOnline",
            body: fileData,
            method: "post",
            contentType: "json",
            callBack:(response)=>{
                if (response) {
                    if(type === 1) {
                        message.success("上传成功");
                    }else if(type === 2) {
                        message.success("删除成功");
                    }
                }
            }
        })
    }

    getElectricRecordTable() {
        this.request({
            url: "/cm-sites-media-consumer/system/saveRecordOnlineOpen",
            method: "post",
            body: { open: this.state.positionRecordOnlineOpen },
            callBack: (response)=>{}
        })
    }

    getDifferentRecordOnline() {
        this.request({
            url: "/cm-sites-media-consumer/system/saveDifferentRecord",
            method: "post",
            body: { open: this.state.differentRecordOnline },
            callBack: (response)=>{}
        })
    }

    getSystemSetting() {
        this.request({
            url: "/cm-sites-media-consumer/system/getCustomInfo",
            callBack: (response)=>{
                if (response) {
                    let tempFileList = [];
                    let positionRecordOnlineList = [];
                    if (response.positionRecord) {
                        tempFileList[0] = {...response.positionRecord,uid:response.positionRecord?._id,url:response.positionRecord?.path,status: "done"}
                    }
                    if (response?.positionRecordOnline) {
                        positionRecordOnlineList[0] = {...response.positionRecordOnline,uid:response.positionRecordOnline?._id,url:response.positionRecordOnline?.path,status: "done"}
                    }
                    this.setState({
                        itemCode:response.itemCode,
                        vsbHost: response.vsbHost,
                        tenantId: response.tenantId,
                        fileList:  tempFileList,
                        positionRecordOnlineList,
                        positionRecordOnlineOpen: response.positionRecordOnlineOpen,
                        differentRecordOnline: response.differentRecordOnline,
                    }, () => {
                        this.getElectricRecordTable();
                    })
                }
            }
        })
    }

    clickDownload(file) {
        let path = file.path;
        if (path.indexOf("?") === -1) {
            window.location.href = path + "?download=1";
        } else {
            window.location.href = path + "&download=1";
        }
    }
}
export default SystemSetting;